module.exports = __webpack_public_path__ + "static/media/6.87368841.png";